import AppModule from "@/app/modules/module";
import Guards from '@/app/middleware/guards'
import {authManager, webManager,authManagerCheckProfile,authManagerCheckPayment} from '@/app/middleware/register'

export default new AppModule('c-user')
    .routers([
        {
            path: '/company/',
            component: AppModule.layout.CompanyLayout,
            beforeEnter: Guards([webManager,authManager,authManagerCheckProfile,authManagerCheckPayment]),
            children: [
                {
                    path: 'worker-detail/:id',
                    name: 'manager.worker-detail',
                    component: () => import('./views/worker-detail'),
                    meta:{
                        title:'職人詳細',
                    }
                },
                {
                    path: 'worker-entry/:id/:projectId',
                    name: 'manager.worker-evaluation',
                    component: () => import('./views/worker-evaluation'),
                    meta : {
                        title: '職人評価'
                    }
                },
                {
                    path: 'worker-result',
                    name: 'manager.worker-result',
                    component: () => import('./views/worker-result'),
                    meta: {
                        title: '検索結果',
                    }
                },
                {
                    path: 'edit-profile',
                    name: 'manager.edit-profile',
                    component: () => import('./views/profile'),
                    meta: {
                        title: '会社情報編集',
                    }
                },

                {
                    path: 'case-detail',
                    name: 'manager.case-detail',
                    component: () => import('./views/case-detail'),
                    meta: {
                        title: '会社被評価 –',
                    }
                },
                // {
                //     path: 'worker-entry/:id',
                //     name: 'manager.worker-entry',
                //     component: () => import('./views/worker-entry'),
                //     meta:{
                //         title:'職人詳細',
                //     }
                // },
            ]
        },
        {
            path: '/company/',
            component: AppModule.layout.CompanyLayout,
            beforeEnter: Guards([webManager,authManager]),
            children: [

                {
                    path: 'create-profile',
                    name: 'manager.create-profile',
                    component: () => import('./views/create-profile'),
                    meta: {
                        title: '会社情報登録',
                    }
                },
            ]
        },
        {
            path: '/company/',
            component: AppModule.layout.FullLayout,
            beforeEnter: Guards([webManager]),
            children: [
                {
                    path: 'created-profile',
                    name: 'manager.created-profile',
                    component: () => import('./views/created-profile'),
                    meta: {bodyClass: 'body-login', title: 'Basb - Created Profile'},
                },
            ]
        }
    ])
    .register()
